// extracted by mini-css-extract-plugin
export default {"page":"IS-z","cartModal":"JS-z","checkout":"KS-z","placeholder":"LS-z","account":"MS-z"};